import React from 'react';
import styled from 'styled-components';
import SectionHeading from '../../components/common/SectionHeading';

const Wrapper = styled.section`
  background: ${({ theme }) => theme.colors.surface};
  border-radius: 1.5rem;
  padding: 3.5rem;
  box-shadow: ${({ theme }) => theme.shadows.md};
  display: grid;
  grid-template-columns: minmax(0, 1.2fr) minmax(0, 0.8fr);
  gap: 4rem;
  align-items: start;

  @media (max-width: 968px) {
    grid-template-columns: minmax(0, 1fr);
    gap: 3rem;
    padding: 2.5rem;
  }

  @media (max-width: 768px) {
    padding: 2rem;
    gap: 2.5rem;
  }
`;

const ContentBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

const GreetingText = styled.div`
  color: ${({ theme }) => theme.colors.textPrimary};
  font-size: 1.125rem;
  line-height: 1.8;
  word-break: keep-all;
`;

const Paragraph = styled.p`
  margin: 0;
  line-height: 1.8;
  color: ${({ theme }) => theme.colors.textPrimary};
`;

const ParagraphGroup = styled.div`
  margin-bottom: 1.75rem;
  
  &:last-child {
    margin-bottom: 0;
  }
  
  ${Paragraph} {
    margin-bottom: 0;
    
    & + ${Paragraph} {
      margin-top: 0;
    }
  }
`;

const FirstParagraph = styled(Paragraph)`
  margin-bottom: 1.75rem;
`;

const SignatureBox = styled.div`
  margin-top: 2rem;
  padding-top: 2rem;
  border-top: 2px solid ${({ theme }) => theme.colors.surfaceMuted};
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.5rem;
`;

const SignatureText = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.textMuted};
  font-size: 1rem;
  font-weight: 500;
`;

const ImageContainer = styled.div`
  position: sticky;
  top: 100px;
  border-radius: 1.5rem;
  overflow: hidden;
  box-shadow: ${({ theme }) => theme.shadows.xl};
  background: ${({ theme }) => theme.colors.surfaceMuted};
  aspect-ratio: 3 / 4;
  width: 100%;
  max-width: 100%;
  border: 2px solid ${({ theme }) => theme.colors.primary}15;
  transition: ${({ theme }) => theme.transitions.default};
  
  @media (max-width: 968px) {
    position: static;
    max-width: 400px;
    margin: 0 auto;
  }
  
  &:hover {
    border-color: ${({ theme }) => theme.colors.primary}30;
    box-shadow: ${({ theme }) => theme.shadows.lg};
    transform: translateY(-2px);
  }
`;

const ProfileImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`;

const GreetingPage = () => {
  return (
    <Wrapper>
      <ContentBox>
        <SectionHeading 
          eyebrow="인사말" 
          title="원장 인사말" 
        />
        <GreetingText>
          <FirstParagraph>
            안녕하세요, 에이스코딩학원 원장 정두루입니다.
          </FirstParagraph>
          
          <ParagraphGroup>
            <Paragraph>
              아이들이 스스로 미래를 만들어갈 수 있는 힘을 기를 수 있도록,
            </Paragraph>
            <Paragraph>
              에이스코딩학원은 '생각을 현실로 만드는 코딩 교육'을 지향합니다.
            </Paragraph>
          </ParagraphGroup>
          
          <ParagraphGroup>
            <Paragraph>
              코딩은 단순한 기술을 넘어 상상한 것을 구현할 수 있는 능력,
            </Paragraph>
            <Paragraph>
              문제를 만나도 끝까지 해결해내는 논리적 사고력,
            </Paragraph>
            <Paragraph>
              그리고 AI 시대에 필요한 기술 활용 능력을 길러주는 가장 강력한 도구입니다.
            </Paragraph>
          </ParagraphGroup>
          
          <ParagraphGroup>
            <Paragraph>
              에이스코딩학원은 아이 한 명 한 명의 속도에 맞춘 맞춤형 수업과
            </Paragraph>
            <Paragraph>
              결과물이 눈에 보이는 실습 중심 프로젝트로
            </Paragraph>
            <Paragraph>
              아이들의 성장을 책임감 있게 이끌어가겠습니다.
            </Paragraph>
          </ParagraphGroup>
          
          <ParagraphGroup>
            <Paragraph>
              아이들이 코딩을 통해 자신감을 얻고,
            </Paragraph>
            <Paragraph>
              미래를 스스로 만들어 갈 수 있도록 끝까지 함께하겠습니다.
            </Paragraph>
          </ParagraphGroup>
          
          <ParagraphGroup>
            <Paragraph>
              감사합니다.
            </Paragraph>
          </ParagraphGroup>
        </GreetingText>
        
        <SignatureBox>
          <SignatureText>에이스코딩학원 원장 정두루 드림</SignatureText>
        </SignatureBox>
      </ContentBox>
      
      <ImageContainer>
        <ProfileImage 
          src="/assets/director-profile.jpg" 
          alt="에이스코딩학원 원장 정두루"
        />
      </ImageContainer>
    </Wrapper>
  );
};

export default GreetingPage;
